import { Injectable, inject } from '@angular/core';
import { BoelsBaseSite } from '@boels/models';
import { combineLatest, filter, Observable, take } from 'rxjs';
import { CultureFacade } from '../../cultures/facade/cultures.facade';
import { SiteContextFacade } from '../../site-context/facade/site-context.facade';

@Injectable({
  providedIn: 'root',
})
export class ApiContextService {
  private siteContextFacade = inject(SiteContextFacade);
  private cultureFacade = inject(CultureFacade);

  getContext(): Observable<
    [baseSite: BoelsBaseSite, language: string, currency: string]
  > {
    return combineLatest([
      this.siteContextFacade.getActiveBaseSiteEntity(),
      this.cultureFacade.getActiveLanguage(),
      this.cultureFacade.getActiveCurrency(),
    ]).pipe(
      filter(
        ([baseSite, lang, currency]) => !!baseSite && !!lang && !!currency,
      ),
      take(1),
    );
  }
}
